import React, { useEffect, useState, useMemo, useRef } from 'react';

import {
  Snackbar,
  Alert,
  AlertTitle,
} from '@mui/material';

const MazTuInfoBeesToast = (props) => {
  const { snackbar, setSnackbar } = props;

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={() =>
        setSnackbar({
          open: false,
          message: snackbar.message,
          title: snackbar.title,
          type: snackbar.severity,
        })
      }
    >
      <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
        {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default MazTuInfoBeesToast;
